var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "divBox",
    },
    [
      _c("search-page", {
        directives: [
          {
            name: "hasPermi",
            rawName: "v-hasPermi",
            value: ["platform:marketing:sign-challenge:list"],
            expression: "['platform:marketing:sign-challenge:list']",
          },
        ],
        ref: "searchPage",
        attrs: {
          "form-data": _vm.formData,
          columns: _vm.columns,
          request: _vm.getList,
        },
        scopedSlots: _vm._u([
          {
            key: "page-operation",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "mb8" },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "hasPermi",
                            rawName: "v-hasPermi",
                            value: ["platform:marketing:sign-challenge:create"],
                            expression:
                              "['platform:marketing:sign-challenge:create']",
                          },
                        ],
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.handleAdd },
                      },
                      [_vm._v("新增活动")]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "table-status",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("el-switch", {
                  attrs: {
                    "active-value": 1,
                    "inactive-value": 0,
                    "active-text": "上架",
                    "inactive-text": "下架",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.handleStatusChange(row)
                    },
                  },
                  model: {
                    value: row.status,
                    callback: function ($$v) {
                      _vm.$set(row, "status", $$v)
                    },
                    expression: "row.status",
                  },
                }),
              ]
            },
          },
          {
            key: "table-append",
            fn: function () {
              return [
                _c("el-table-column", {
                  attrs: {
                    fixed: "right",
                    label: "操作",
                    align: "center",
                    "min-width": "220",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _c(
                            "p",
                            [
                              _c(
                                "span",
                                { staticStyle: { "padding-right": "5px" } },
                                [_vm._v("操作")]
                              ),
                              _c("right-toolbar", {
                                attrs: { columns: _vm.columns },
                                on: { refresh: _vm.refreshList },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.handleActData(row)
                                },
                              },
                            },
                            [_vm._v("活动数据")]
                          ),
                          _c("el-divider", {
                            attrs: { direction: "vertical" },
                          }),
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.handleRecord(row)
                                },
                              },
                            },
                            [_vm._v("打卡明细")]
                          ),
                          [
                            _c("el-divider", {
                              attrs: { direction: "vertical" },
                            }),
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.handleItem(row, "edit")
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                          ],
                          [
                            _c("el-divider", {
                              attrs: { direction: "vertical" },
                            }),
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDelete(row)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ],
                        ]
                      },
                    },
                  ]),
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("act-info", {
        attrs: { id: _vm.infoOptions.id },
        model: {
          value: _vm.infoOptions.show,
          callback: function ($$v) {
            _vm.$set(_vm.infoOptions, "show", $$v)
          },
          expression: "infoOptions.show",
        },
      }),
      _c("act-record", {
        attrs: { id: _vm.recordOptions.id },
        model: {
          value: _vm.recordOptions.show,
          callback: function ($$v) {
            _vm.$set(_vm.recordOptions, "show", $$v)
          },
          expression: "recordOptions.show",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }